/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import * as THREE from 'three';
import { useConfigurationStore } from '@/stores/configurationModule';
/**
 *
 * @param {THREE.Raycaster} raycaster
 * @param {THREE.WebGLRenderer} renderer
 * @param {THREE.Camera} camera
 * @param {THREE.Vector2} mouse
 * @param {THREE.Scene} scene
 * @param {THREE.Mesh} box
 * @returns
 *
 */
export default function use3dMouseSelect(raycaster, renderer, camera, mouse, scene, box, element) {
  const $eventBus = inject('bus');
  const configurationStore = useConfigurationStore();
  const {
    setHoveredPanel,
    setIsHoveredPanelInside,
    setIsActivePanelInside
  } = configurationStore;
  const {
    hasInsidePrinting,
    insideMaterialColor
  } = storeToRefs(configurationStore);
  if (!(raycaster instanceof THREE.Raycaster)) {
    raycaster = new THREE.Raycaster();
  }
  function onMouseMove(event) {
    event.preventDefault();

    // Get the size of the canvas element
    const canvasBounds = renderer.domElement.getBoundingClientRect();
    const canvasWidth = canvasBounds.width;
    const canvasHeight = canvasBounds.height;

    // Adjust mouse coordinates based on the canvas size
    mouse.x = (event.clientX - canvasBounds.left) / canvasWidth * 2 - 1;
    mouse.y = -((event.clientY - canvasBounds.top) / canvasHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObject(scene, true);
    scene.traverse(c => {
      if (c.isMesh) {
        const insideMatIndex = c.outsideMatIndex === 0 ? 1 : 0;
        c.material[c.outsideMatIndex].color.set(0xffffff);
        if (!hasInsidePrinting.value) {
          c.material[insideMatIndex].color.set(insideMaterialColor.value);
        } else {
          c.material[insideMatIndex].color.set(0xffffff);
        }
      }
    });
    if (intersects.length > 0) {
      const object = intersects[0].object;
      const insideMatIndex = object.outsideMatIndex === 1 ? 0 : 1;
      const hasFace = intersects[0]?.face;
      if (hasFace && intersects[0]?.face?.materialIndex === object.outsideMatIndex) {
        setIsHoveredPanelInside(false);
        setHoveredPanel(object.panelName?.split(" ")[0]);
        object.material[object.outsideMatIndex]?.color.set(0xffff00);
      } else if (hasFace && intersects[0]?.face.materialIndex === insideMatIndex && hasInsidePrinting.value) {
        setIsHoveredPanelInside(true);
        setHoveredPanel(object.panelName?.split(" ")[0]);
        object.material[insideMatIndex]?.color.set(0xffff00);
      } else {
        setIsHoveredPanelInside(false);
        setHoveredPanel('');
      }
    } else {
      setIsHoveredPanelInside(false);
      setHoveredPanel('');
    }
  }
  function onMouseDown(event) {
    event.preventDefault();

    // Get the size of the canvas element
    const canvasBounds = renderer.domElement.getBoundingClientRect();
    const canvasWidth = canvasBounds.width;
    const canvasHeight = canvasBounds.height;

    // Adjust mouse coordinates based on the canvas size
    mouse.x = (event.clientX - canvasBounds.left) / canvasWidth * 2 - 1;
    mouse.y = -((event.clientY - canvasBounds.top) / canvasHeight) * 2 + 1;
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObject(scene, true);
    if (intersects.length > 0) {
      const object = intersects[0].object;
      const insideMatIndex = object.outsideMatIndex === 1 ? 0 : 1;
      const hasFace = intersects[0]?.face;
      if (hasFace && intersects[0].face.materialIndex === object.outsideMatIndex) {
        if (object.material[0]?.map === null) {
          return;
        }
        setIsActivePanelInside(false);
        $eventBus.$emit('panel-selected', object.panelName.split(" ")[0]);
      } else if (hasFace && intersects[0].face.materialIndex === insideMatIndex && hasInsidePrinting.value) {
        if (object.material[1]?.map === null) {
          return;
        }
        setIsActivePanelInside(true);
        $eventBus.$emit('panel-selected', object.panelName.split(" ")[0]);
      }
    }
  }
  element.addEventListener('mousemove', e => {
    onMouseMove(e);
  });
  element.addEventListener('mousedown', e => {
    onMouseDown(e);
  });
}